<section fxLayout="column">
  <vdw-header [title]="dialogTitle | bmsTranslate" [svgIcon]="dialogIcon" [canShowClose]="true"></vdw-header>
  <article class="dialog-content" fxLayout="row">
    <div fxLayout="column" fxFlex="100" fxLayoutGap="24px">
      <vdw-message-container *ngIf="hasErrorMessages()" [messages]="errorMessages"> </vdw-message-container>

      <vdw-message-container *ngIf="hasWarningMessages()" [messages]="warningMessages"> </vdw-message-container>
    </div>
  </article>
</section>
